import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';

/** Un mes de la campaña. Espejo de `MesRecordatorio` de la API. */
export interface MesRecordatorio {
  ciclo: string;
  enviados: number;
  volvieron14d: number;
  bajas: number;
}

/** Espejo de `ResumenRecordatorio` del modulo `recordatorio-inactividad`. */
export interface ResumenRecordatorio {
  encendido: boolean;
  soloProd: boolean;
  /** El criterio de quien recibe el correo. Solo se muestra, no se edita. */
  criterio: {
    diasSinOperar: number;
    diasSinConexion: number;
    maxMesesSeguidos: number;
  };
  proximaCorrida: string;
  corrida: { ciclo: string; estado: string } | null;
  /** Los que califican hoy: el dia 1 salen todos. */
  candidatosHoy: number;
  meses: MesRecordatorio[];
  bajasTotal: number;
}

export interface Pagina<T> {
  items: T[];
  total: number;
  page: number;
  limit: number;
}

export interface EnvioRecordatorio {
  enviadoAt: string;
  ciclo: string;
  nombre: string;
  email: string;
  volvio: boolean;
}

export interface BajaRecordatorio {
  createdAt: string;
  nombre: string;
  email: string;
  origen: string;
}

/**
 * El recordatorio mensual a clientes que dejaron de operar, visto desde el
 * panel de operadores. El envio lo hace el cron del dia 1; desde aca solo se
 * prende o apaga, se manda una prueba, se da de baja a mano y se revisa.
 */
@Injectable({ providedIn: 'root' })
export class RecordatorioInactividadService {
  private baseUrl = `${environment.apiNest}recordatorio-control`;

  constructor(private http: HttpClient) {}

  resumen(): Promise<ResumenRecordatorio> {
    return firstValueFrom(this.http.get<ResumenRecordatorio>(`${this.baseUrl}/resumen`));
  }

  cambiarInterruptor(encendido: boolean): Promise<ResumenRecordatorio> {
    return firstValueFrom(
      this.http.put<ResumenRecordatorio>(`${this.baseUrl}/interruptor`, { encendido })
    );
  }

  enviarPrueba(): Promise<{ enviadoA: string }> {
    return firstValueFrom(this.http.post<{ enviadoA: string }>(`${this.baseUrl}/prueba`, {}));
  }

  darDeBaja(email: string): Promise<{ usuarios: number }> {
    return firstValueFrom(this.http.post<{ usuarios: number }>(`${this.baseUrl}/baja`, { email }));
  }

  envios(page: number, limit: number, q: string): Promise<Pagina<EnvioRecordatorio>> {
    return firstValueFrom(
      this.http.get<Pagina<EnvioRecordatorio>>(`${this.baseUrl}/envios`, {
        params: this.pagina(page, limit, q),
      })
    );
  }

  bajas(page: number, limit: number, q: string): Promise<Pagina<BajaRecordatorio>> {
    return firstValueFrom(
      this.http.get<Pagina<BajaRecordatorio>>(`${this.baseUrl}/bajas`, {
        params: this.pagina(page, limit, q),
      })
    );
  }

  private pagina(page: number, limit: number, q: string): HttpParams {
    let params = new HttpParams().set('page', page).set('limit', limit);
    if (q.trim()) params = params.set('q', q.trim());
    return params;
  }
}
